import { render, staticRenderFns } from "./IndentRegistry.vue?vue&type=template&id=4ab70ecc&"
import script from "./IndentRegistry.vue?vue&type=script&lang=js&"
export * from "./IndentRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports